import type { AwsRum } from 'aws-rum-web';

declare global {
  interface Window {
    AwsRum?: AwsRum;
  }
}

const JOURNEY_ATTRIBUTE = 'journeyId';

let latestJourneyId: string | null = null;

const tag = (rum: AwsRum | undefined): void => {
  if (rum && latestJourneyId) rum.addSessionAttributes({ [JOURNEY_ATTRIBUTE]: latestJourneyId });
};

/** Tag the RUM session with the BFF's journeyId, so its errors, requests and replay lead to that journey's BFF log lines. */
export const tagRumJourney = (journeyId: string): void => {
  if (journeyId === latestJourneyId) return;
  latestJourneyId = journeyId;
  tag(typeof window === 'undefined' ? undefined : window.AwsRum);
};

/** RUM starts after the first session call can return, so it picks up the journey it missed. */
export const applyRumJourney = (rum: AwsRum): void => tag(rum);
